import React, { Fragment } from "react";
import { Link } from "react-router-dom";
var truncate = require("truncate");

const BlogCard2 = ({ data }) => {
  return (
    <Fragment>
      <Link to={`/NewsDetails/${data.id}`}>
        <div className="card border-0 text-dark">
          <div className="row">
            <div className="col-lg-3">
              <img
                src="/images/company2.jpg"
                className="card-img-top rounded"
                alt="..."
              />
            </div>
            <div className="col-lg-9">
              <p className="card-text"> {truncate(data.long_text, 100)}</p>
            </div>
          </div>
        </div>
      </Link>
    </Fragment>
  );
};

export default BlogCard2;
